import React from 'react';
import styles from './SuccessPage.module.scss';
import LogoHeader from '../../components/LogoHeader/LogoHeader';

const SuccessPage = () => (
  <div className={styles.SuccessPage} data-testid="SuccessPage">
    <div className={styles.SuccessModal}>
      <LogoHeader />
      <div className={styles.SuccessBody}>
        <h5>Success!</h5>
        <div>You have successfully submitted your current week Timesheet.</div>
      </div>
    </div>
  </div>
);

export default SuccessPage;
